module.exports = __webpack_public_path__ + "assets/img/under-development.9d350358.png";